<template>
  <DialogComponent v-model="isShowing"
                   :title="$t('collaborate-dialog-title')"
  >
    <div class="share-program-dialog">

      <div class="email-input-wrapper">
        <div class="email-input">
          <TextfieldComponent v-model="email"
                              :loading="loading"
                              :disable="loading"
                              :placeholder="$t('email')"
                              :hide-bottom-space="true"
                              type="email"
                              :hint="$t('collaborate-dialog-hint')"
                              dense
                              ref="inputRef"
                              @update:model-value="onUpdate"
          ></TextfieldComponent>
        </div>
        <div class="button-wrapper">
          <button type="button" class="icon compact" aria-label="Add" @click="onShare" :disabled="loading || !validEmail">
            <QIcon name="add"></QIcon>
          </button>
        </div>
      </div>

      <div class="account-list-wrapper">
        <div class="typography">
          <h4>{{ $t('people-with-access') }}</h4>
        </div>

        <TransitionGroup name="list" tag="ul" class="account-list">

          <li v-for="(account, index) in submission.sharedWith" :key="index" class="account-item">
            <Avatar :account="account"></Avatar>
            <div class="account-meta typography">
              <div class="account-meta-name visually-p">{{ account.getFullName() }}</div>
              <div class="account-meta-email visually-p">{{ account.getEmail() }}</div>
            </div>
          </li>

        </TransitionGroup>
      </div>

      <button type="button" @click="isShowing = false">{{ $t('done') }}</button>

    </div>
  </DialogComponent>
</template>

<script lang="ts" setup>
import { ref, defineExpose } from 'vue';
import Submission from '../../quality-mentoring-form/models/submission/Submission';
import Avatar from '../../../components/AvatarComponent.vue';
import { testPattern } from '../../../lib/quasar/src/utils/patterns';

const isShowing = ref(false);

const email = ref();

const submission = ref<Submission>();

const loading = ref(false);

const validEmail = ref(false);

const inputRef = ref();

const onUpdate = (val) => {
  validEmail.value = testPattern.email(val);
}

const onShare = async () => {
  loading.value = true;
  await submission.value.share(email.value);
  await submission.value.load(submission.value.id);
  email.value = '';
  inputRef.value.focus();
  loading.value = false;
  validEmail.value = false;
}

const show = (aSubmission: Submission) => {
  submission.value = aSubmission;
  isShowing.value = true;
}

defineExpose({
  show
})

</script>

<style lang="scss" scoped>
.share-program-dialog {
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width: 400px;

  .email-input-wrapper {
    display: flex;
    gap: 10px;
    .email-input {
      flex: 1 1 auto;
    }
    .button-wrapper {
      display: flex;
      align-items: center;
      height: 40px;
    }
  }

  .account-list-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .account-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
    .account-item {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .typography {
      --spacing: 0.25em;
    }
    .account-meta-name,
    .account-meta-email {
      --line-height: normal;
    }
    .account-meta-name {
      --color: var(--heading-color);
      --font-size: 13;
    }
    .account-meta-email {
      --font-size: 11;
    }
    .list-move,
    .list-enter-active,
    .list-leave-active {
      transition: all 500ms;
    }
    .list-enter-from,
    .list-leave-to {
      opacity: 0;
      transform: translateX(20px);
    }
  }
}
</style>
